"use strict";
import subscribable from "./Subscribable";

module.exports = (flex = window.flex) => {

    const Subscribable = subscribable(flex);

    class KeyState extends Subscribable {
        constructor(...args) {
            super(...args);
            this.state = {};
            this._initialize();
        }

        _initialize() {
            document.body.addEventListener('keydown', (event) => {
                this.state[event.keyCode] = true;
                this.broadcast();
            });
            document.body.addEventListener('keyup', (event) => {
                this.state[event.keyCode] = false;
            });
        }

        broadcast() {
            this.subscriptions.forEach(({ condition, callback }) => {
                let active = condition.reduce((output, keyCode) => {
                    return output && this.state[keyCode];
                }, true);

                if (active) {
                    callback();
                }
            });
        }
    }

    return KeyState;
};